<template>
  <CurrentIcon v-if="CurrentIcon" :rotate="props.rotate" :spin="props.spin" />
  <template v-else />
</template>

<script setup lang="ts">
import {
  ArrowDownOutlined,
  ArrowLeftOutlined,
  ArrowRightOutlined,
  ArrowUpOutlined,
  AuditOutlined,
  BarsOutlined,
  BellOutlined,
  CloseCircleOutlined,
  CloseOutlined,
  CommentOutlined,
  CopyOutlined,
  DeleteOutlined,
  EditFilled,
  EditOutlined,
  ExpandAltOutlined,
  FileOutlined,
  FilePdfOutlined,
  FilterOutlined,
  LoadingOutlined,
  LogoutOutlined,
  MenuOutlined,
  PlusCircleOutlined,
  PlusOutlined,
  UploadOutlined,
  UserOutlined,
} from '@ant-design/icons-vue';

import {EAntIconUrl} from '@/assets/ant/icon/enums';

const icons = {
  [EAntIconUrl.ARROW_DOWN_OUTLINED]: ArrowDownOutlined,
  [EAntIconUrl.ARROW_LEFT_OUTLINED]: ArrowLeftOutlined,
  [EAntIconUrl.ARROW_RIGHT_OUTLINED]: ArrowRightOutlined,
  [EAntIconUrl.ARROW_UP_OUTLINED]: ArrowUpOutlined,
  [EAntIconUrl.AUDIT_OUTLINED]: AuditOutlined,
  [EAntIconUrl.BARS_OUTLINED]: BarsOutlined,
  [EAntIconUrl.BELL_OUTLINED]: BellOutlined,
  [EAntIconUrl.CLOSE_CIRCLE_OUTLINED]: CloseCircleOutlined,
  [EAntIconUrl.CLOSE_OUTLINED]: CloseOutlined,
  [EAntIconUrl.COMMENT_OUTLINED]: CommentOutlined,
  [EAntIconUrl.COPY_OUTLINED]: CopyOutlined,
  [EAntIconUrl.PLUS_CIRCLE_OUTLINED]: PlusCircleOutlined,
  [EAntIconUrl.PLUS_OUTLINED]: PlusOutlined,
  [EAntIconUrl.EDIT_OUTLINED]: EditOutlined,
  [EAntIconUrl.EDIT_FILLED]: EditFilled,
  [EAntIconUrl.DELETE_OUTLINED]: DeleteOutlined,
  [EAntIconUrl.FILE_OUTLINED]: FileOutlined,
  [EAntIconUrl.FILE_PDF_OUTLINED]: FilePdfOutlined,
  [EAntIconUrl.FILTER_OUTLINED]: FilterOutlined,
  [EAntIconUrl.LOADING_OUTLINED]: LoadingOutlined,
  [EAntIconUrl.LOGOUT_OUTLINED]: LogoutOutlined,
  [EAntIconUrl.MENU_OUTLINED]: MenuOutlined,
  [EAntIconUrl.UPLOAD_OUTLINED]: UploadOutlined,
  [EAntIconUrl.USER_OUTLINED]: UserOutlined,
  [EAntIconUrl.EXPAND_ALT_OUTLINED]: ExpandAltOutlined,
};

interface IProps {
  url?: EAntIconUrl;

  rotate?: number;
  spin?: boolean;
}

const props = defineProps<IProps>();

const CurrentIcon = props.url != undefined ? icons[props.url] : undefined;
</script>

<style lang="scss" />
